import {
  VERSION_STATE_OPEN,
  VERSION_STATE_TERMINATED,
  VERSION_STATE_CLOSED,
  VERSION_STATE_DRAFT
} from './ApiTypes';

import styles from '../components/stylesheets/_variables.scss';

export const STATUS_STYLE_MAP = {
  [VERSION_STATE_OPEN]: styles.openVersionColor,
  [VERSION_STATE_TERMINATED]: styles.terminatedVersionColor,
  [VERSION_STATE_CLOSED]: styles.closedVersionColor,
  [VERSION_STATE_DRAFT]: styles.draftVersionColor
};

export const DELAY_ICON = '#common-timer';
export const DELAY_FILL_COLOR = styles.delayNodeColor;
export const EVENT_LISTENER_ICON = '#common-event';
export const EVENT_LISTENER_FILL_COLOR = styles.eventListenerNodeColor;
export const MESSAGE_ICON = '#common-message';
export const MESSAGE_FILL_COLOR = styles.messageNodeFillColor;

export const ENTRY_EVENT_HEADER_CIRCLE_COLOR =
  styles.entryEventHeaderCircleColor;
export const ICON_FILL_COLOR = styles.iconFillColor;



// WEBPACK FOOTER //
// ./src/constants/Style.js